import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

import React, { useEffect, useRef } from "react"
import Lenis from "@studio-freight/lenis"
import { useLocation } from "@reach/router"

const WrapWithLenis = ({ element }) => {
  // lenisインスタンスを保持するためのref
  const lenisRef = useRef(null)
  const location = useLocation()

  useEffect(() => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true })
    }
  }, [location.pathname])

  useEffect(() => {
    if (typeof window === "undefined") return

    // 初期化
    const lenis = new Lenis({
      duration: 1.5,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // 慣性を少し自然に
      smoothWheel: true,
      touchMultiplier: 2, // スマホ等での感度調整
    })
    
    lenisRef.current = lenis

    // raf(RequestAnimationFrame) の管理
    let rafId
    const raf = (time) => {
      lenis.raf(time)
      rafId = requestAnimationFrame(raf)
    }
    rafId = requestAnimationFrame(raf)

    // クリックイベントの委譲（効率的なイベント監視）
    const handleClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]')
      if (!anchor) return

      const href = anchor.getAttribute("href")
      // ヘッダーの高さなどを考慮したオフセット
      const offset = window.innerWidth < 896 ? -100 : -170

      if (href === "#") {
        lenis.scrollTo(0)
      } else {
        const targetElement = document.querySelector(href)
        if (targetElement) {
          e.preventDefault()
          lenis.scrollTo(targetElement, { offset })
        }
      }
    }

    window.addEventListener("click", handleClick, { passive: false })

    return () => {
      cancelAnimationFrame(rafId)
      window.removeEventListener("click", handleClick)
      lenis.destroy()
    }
  }, [])

  return <>{element}</>
}

export const wrapPageElement = ({ element }) => {
  return <WrapWithLenis element={element} />
}
